export class PageLoaderManager {
    static async setSpinnerVisibility(show: boolean) {
        document.getElementById("spinner").classList.toggle("show", show);
    }
}